import React, { useState, useRef, useEffect, useContext } from 'react';
import { toast } from 'react-toastify';
import Label from '../../components/form/Label';
import { uuidv4 } from '@/utils/uuid';
import DeckService from '@/services/decks.service';
import { GenerateContext } from './CreateFlashcardWithAI';
import FlashcardService from '@/services/flashcard.service';

const ChoiceAnswer = ["A", "B", "C", "D"];

export default function AIImportFlashcardsModal() {
  const { flashCards, setFlashCards, deck_id } = useContext(GenerateContext);
  const mapData = flashCards.map((flashcard: any) => ({
    question: flashcard.title_FC,
    answer: flashcard.answer,
    image: "",
    sound: "",
    definition: flashcard.definition,
    moreQuestions: flashcard.moreQuestions.map((question: any, index: number) => ({
      id: index + 1,
      ...question
    }))
  }))
  const [expandedCards, setExpandedCards] = useState<number[]>([]);
  const [showExcelModal, setShowExcelModal] = useState(flashCards.length > 0);
  const [excelData, setExcelData] = useState<any[]>(mapData);
  const excelInputRef = useRef<HTMLInputElement>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [deckData, setDeckData]: any = useState({
    flashcards: mapData,
  });


  const validate = () => {
    let firstErrorElementId: HTMLElement | null = null;

    let checkValidate = false;
    const flashcards = deckData.flashcards;

    let firstErrorElement: HTMLElement | null = null;
    let firstErrorIndex = -1;

    for (let i = 0; i < flashcards.length; i++) {
      const it = flashcards[i];

      // Check main fields
      if (
        it.question.trim() === "" ||
        it.answer.trim() === "" ||
        it.definition.trim() === "" ||
        it.question.split("\n").length > 3 ||
        it.answer.split("\n").length > 3 ||
        it.definition.split("\n").length > 3
      ) {
        const element = document.getElementById(`flashcard-main-${i}`);
        if (element && !firstErrorElement) {
          firstErrorElement = element;
        }
        checkValidate = true;
        firstErrorIndex = i;
        break;
      }

      // Check additional questions
      for (let j = 0; j < it.moreQuestions.length; j++) {
        const question = it.moreQuestions[j];

        if (!question.question || question.question.trim() === "" || question.question.split("\n").length > 3) {
          const element = document.getElementById(`question-${i}-${j}`);
          if (element && !firstErrorElement) {
            firstErrorElement = element;
          }
          checkValidate = true;
          firstErrorIndex = i;
        }

        if (!question.type) {
          const element = document.getElementById(`type-${i}-${j}`);
          if (element && !firstErrorElement) {
            firstErrorElement = element;
          }
          checkValidate = true;
          firstErrorIndex = i;
        }

        for (let k = 0; k < question.answer.length; k++) {
          const ans = question.answer[k];
          if (!ans || ans.trim() === "" || ans.split("\n").length > 3) {
            const element = document.getElementById(`answer-${i}-${j + 1}-${k}`);
            if (element && !firstErrorElement) {
              firstErrorElement = element;
            }
            checkValidate = true;
            firstErrorIndex = i;
          }
        }

        if (!question.correctAnswer || question.correctAnswer.trim() === "" || question.correctAnswer.split("\n").length > 3) {
          const element = document.getElementById(`correct-answer-${i}-${j}`);
          if (element && !firstErrorElement) {
            firstErrorElement = element;
          }
          checkValidate = true;
          firstErrorIndex = i;
        }
      }

      if (checkValidate) break;
    }

    if (!checkValidate) {
      return false;
    } else {
      if (!firstErrorElementId) {
        if (firstErrorIndex >= 0 && !expandedCards.includes(firstErrorIndex)) {
          setExpandedCards(prev => [...prev, firstErrorIndex]);
        }
        firstErrorElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return true;
    }
  };


  useEffect(() => {
    setShowExcelModal(flashCards.length > 0);
  }, [flashCards.length]);

  const handleImport = () => {
    setIsLoading(true);
    const flashcards = excelData.map(row => {
      let moreQuestions = row.moreQuestions;
      for (let it of moreQuestions) {
        if (ChoiceAnswer.indexOf(it.correctAnswer) >= 0) {
          it.correctAnswer = it.answer[ChoiceAnswer.indexOf(it.correctAnswer)]
        }
      }
      return {
        title_FC: row.question,
        answer: row.answer,
        image: row.image,
        sound: row.sound,
        definition: row.definition,
        moreQuestions: row.moreQuestions
      }
    });

    FlashcardService.importFlashcards({
      deck_id,
      flashcards
    })
      .then((data: any) => {
        if (data.data.status === 200) {
          toast.success('Data imported successfully!');
          setTimeout(() => {
            window.location.href = "/list-flashcards/" + deck_id;
          }, 1500);
        } else {
          toast.error("Create Failed!");
          setIsLoading(false);
        }
      })
      .catch((errors) => {
        setIsLoading(false);
        toast.error("Create Failed!");
      });
  };

  const handleAddMoreQuestion = (index: any) => {
    const newData: any = [...excelData];
    const currentQuestions = newData[index].moreQuestions || [];
    const lastId = currentQuestions.length > 0 ? currentQuestions[currentQuestions.length - 1].id : 0;
    const newQuestion = {
      id: lastId + 1,
      type: "isYesNo",
      question: "",
      answer: ["", ""],
      correctAnswer: ""
    };
    newData[index].moreQuestions = [...currentQuestions, newQuestion];
    setExcelData(newData);
    setDeckData({
      ...deckData,
      flashcards: newData
    });
  };

  const handleRemoveQuestion = (index: any, id: any) => {
    const newData: any = [...excelData];
    const updatedQuestions = newData[index].moreQuestions.filter((q: any) => q.id !== id);
    newData[index].moreQuestions = updatedQuestions;
    setExcelData(newData);
    setDeckData({
      ...deckData,
      flashcards: newData
    });
  };
  const handleQuestionChange = (index: any, id: number, type: string, value: any) => {
    let updateData: any = { [type]: value }
    if (type === "type") {
      if (value === "isYesNo") {
        updateData = { [type]: value, answer: ["", ""], correctAnswer: "" }
      }
      if (value === "isMultiple") {
        updateData = { [type]: value, answer: ["", "", "", ""], correctAnswer: "" }
      }
    }
    const newData: any = [...excelData];
    const updatedQuestions = newData[index].moreQuestions.map((q: any) =>
      q.id === id ? { ...q, ...updateData } : q
    );
    newData[index].moreQuestions = updatedQuestions;
    setExcelData(newData);
    setDeckData({
      ...deckData,
      flashcards: newData
    });
  };

  const handleRemoveAnswer = (index: number, questionData: any, answerIndex: number) => {
    setExcelData(prevExcelData => {
      const newData = [...prevExcelData];
      const updatedQuestions = [...newData[index].moreQuestions];
      const questionIndex = updatedQuestions.findIndex(q => q.id === questionData.id);
      if (questionIndex !== -1) {
        const updatedQuestion = {
          ...updatedQuestions[questionIndex],
          answer: updatedQuestions[questionIndex].answer.filter((_: any, idx: any) => idx !== answerIndex)
        };
        if (updatedQuestions[questionIndex].correctAnswer === ChoiceAnswer[answerIndex]) {
          updatedQuestion.correctAnswer = "";
        }
        updatedQuestions[questionIndex] = updatedQuestion;
        newData[index] = {
          ...newData[index],
          moreQuestions: updatedQuestions
        };
        setDeckData((prev: any) => ({
          ...prev,
          flashcards: newData
        }));
        return newData;
      }
      return prevExcelData;
    });
  };

  const handleAddMoreAnswer = (index: number, questionData: any) => {
    setExcelData(prevExcelData => {
      const newData = [...prevExcelData];
      const updatedQuestions = [...newData[index].moreQuestions];
      const questionIndex = updatedQuestions.findIndex(q => q.id === questionData.id);
      if (questionIndex !== -1) {
        const updatedQuestion = {
          ...updatedQuestions[questionIndex],
          answer: [...updatedQuestions[questionIndex].answer, ""]
        };
        updatedQuestions[questionIndex] = updatedQuestion;
        newData[index] = {
          ...newData[index],
          moreQuestions: updatedQuestions
        };
        setDeckData((prev: any) => ({
          ...prev,
          flashcards: newData
        }));
        return newData;
      }
      return prevExcelData;
    });
  };

  const toggleCard = (index: number) => {
    setExpandedCards(prev =>
      prev.includes(index)
        ? prev.filter(i => i !== index)
        : [...prev, index]
    );
  };

  return (
    <div>
      {showExcelModal && (
        <div className="fixed inset-0 z-50">
          {/* Overlay */}
          <div
            className="absolute inset-0 bg-black/50"
            onClick={() => {
              setShowExcelModal(false);
              setExcelData([]);
              setFlashCards([]);
            }}
          />

          {/* Modal */}
          <div className="relative flex items-center justify-center min-h-screen p-4">
            <div
              className="bg-white rounded-lg p-6 w-[calc(100%-32px)] max-w-[1280px] max-h-[80vh] overflow-auto"
              onClick={(e) => e.stopPropagation()}
            >
              <>
                <div className="fixed inset-0 bg-black bg-opacity-50 z-40" />
                <div className="fixed inset-0 z-50">
                  <div className="flex items-center justify-center min-h-screen p-4">
                    <div className="bg-white rounded-lg p-6 w-[calc(100%-32px)] max-w-[1280px] max-h-[80vh] overflow-auto">
                      <div className="flex justify-between items-center mb-4">
                        <h2 className="text-xl font-semibold">Import Flashcards</h2>
                        <button
                          onClick={() => {
                            setShowExcelModal(false);
                            setExcelData([]);
                            if (excelInputRef.current) {
                              excelInputRef.current.value = '';
                            }
                            setFlashCards([]);
                          }}
                          className="p-2 hover:bg-gray-100 rounded-full"
                        >
                          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </button>
                      </div>
                      <div className="overflow-x-auto">
                        <Label className='mt-6'>Flashcards</Label>
                        <div className="flex">
                          <div className="w-64 bg-gray-100 p-4 mt-4 rounded-md">
                            <h3 className="text-lg font-semibold mb-4">Flashcards List</h3>
                            <ul>
                              {excelData.map((row, index) => (
                                <li
                                  key={index}
                                  className={`cursor-pointer py-2 px-4 hover:bg-gray-300 rounded-md ${expandedCards.includes(index) ? 'bg-gray-300' : ''
                                    }`}
                                  onClick={() => {
                                    setExpandedCards([index]);
                                    const element = document.getElementById(`flashcard-main-${index}`);
                                    if (element) {
                                      element?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                                    }
                                  }}
                                >
                                  Flashcard {index + 1}
                                </li>
                              ))}
                            </ul>
                          </div>
                          <div className="flex-1 p-4">
                            <div className="space-y-4">
                              {excelData.map((row, index) => (
                                <div key={index} id={`flashcard-main-${index}`} className="border border-gray-200 rounded-lg overflow-hidden">
                                  <div
                                    className="flex justify-between items-center p-4 bg-gray-50 cursor-pointer"
                                    onClick={() => toggleCard(index)}
                                  >
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        const newData = [...excelData];
                                        newData.splice(index, 1);
                                        setExcelData(newData);
                                        setDeckData({
                                          ...deckData,
                                          flashcards: newData
                                        });
                                      }}
                                      className="p-2 text-red-600 hover:text-red-800 rounded-full hover:bg-red-100 mr-2"
                                    >
                                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                      </svg>
                                    </button>
                                    {/* <h3 className="font-medium flex-grow">{row.question}</h3> */}
                                    <h3 className="font-medium flex-grow">Flashcard {index + 1}</h3>
                                    <svg
                                      className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${expandedCards.includes(index) ? 'transform rotate-180' : ''}`}
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke="currentColor"
                                    >
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                    </svg>
                                  </div>
                                  {expandedCards.includes(index) && (
                                    <div className="p-4 bg-white">
                                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        {/* Question */}
                                        <div className="space-y-2 md:col-span-2">
                                          <label className="block text-sm font-medium text-gray-700">Question</label>
                                          <textarea
                                            id={`question-main-${index}`}
                                            value={row.question}
                                            onChange={(e) => {
                                              const newData = [...excelData];
                                              newData[index].question = e.target.value;
                                              setExcelData(newData);
                                            }}
                                            placeholder="Please enter question, you can only add line breaks 3 times"
                                            className="w-full min-h-[60px] px-3 py-2 text-base text-gray-900 border border-gray-300 rounded-lg focus:outline-none focus:border-indigo-600"
                                          />
                                          {row.question.trim() === "" && (
                                            <p className="mt-1 text-sm text-red-600 h-6">Question is required</p>
                                          )}
                                          {row.question.split("\n").length > 3 && (
                                            <p className="mt-1 text-sm text-red-600 h-6">You can only add line breaks 3 times</p>
                                          )}
                                        </div>
                                        {/* Answer */}
                                        <div className="space-y-2 md:col-span-2">
                                          <label className="block text-sm font-medium text-gray-700">Answer</label>
                                          <textarea
                                            id={`answer-main-${index}`}
                                            value={row.answer}
                                            onChange={(e) => {
                                              const newData = [...excelData];
                                              newData[index].answer = e.target.value;
                                              setExcelData(newData);
                                              setDeckData({
                                                ...deckData,
                                                flashcards: newData
                                              });
                                            }}
                                            placeholder="Please enter answer, you can only add line breaks 3 times"
                                            className="w-full min-h-[60px] px-3 py-2 text-base text-gray-900 border border-gray-300 rounded-lg focus:outline-none focus:border-indigo-600"
                                          />
                                          {row.answer.trim() === "" && (
                                            <p className="mt-1 text-sm text-red-600 h-6">Answer is required</p>
                                          )}
                                          {row.answer.split("\n").length > 3 && (
                                            <p className="mt-1 text-sm text-red-600 h-6">You can only add line breaks 3 times</p>
                                          )}
                                        </div>
                                        {/* Image URL */}
                                        <div className="space-y-2 md:col-span-2">
                                          <label className="block text-sm font-medium text-gray-700">Image URL (optional)</label>
                                          <textarea
                                            value={row.image}
                                            onChange={(e) => {
                                              const newData = [...excelData];
                                              newData[index].image = e.target.value;
                                              setExcelData(newData);
                                              setDeckData({
                                                ...deckData,
                                                flashcards: newData
                                              });
                                            }}
                                            className="w-full min-h-[60px] px-3 py-2 text-base text-gray-900 border border-gray-300 rounded-lg focus:outline-none focus:border-indigo-600"
                                          />
                                        </div>
                                        {/* Sound URL */}
                                        <div className="space-y-2 md:col-span-2">
                                          <label className="block text-sm font-medium text-gray-700">Sound URL (optional)</label>
                                          <textarea
                                            value={row.sound}
                                            onChange={(e) => {
                                              const newData = [...excelData];
                                              newData[index].sound = e.target.value;
                                              setExcelData(newData);
                                              setDeckData({
                                                ...deckData,
                                                flashcards: newData
                                              });
                                            }}
                                            className="w-full min-h-[60px] px-3 py-2 text-base text-gray-900 border border-gray-300 rounded-lg focus:outline-none focus:border-indigo-600"
                                          />
                                        </div>
                                        {/* Definition */}
                                        <div className="space-y-2 md:col-span-2">
                                          <label className="block text-sm font-medium text-gray-700">Definition</label>
                                          <textarea
                                            id={`definition-main-${index}`}
                                            value={row.definition}
                                            onChange={(e) => {
                                              const newData = [...excelData];
                                              newData[index].definition = e.target.value;
                                              setExcelData(newData);
                                              setDeckData({
                                                ...deckData,
                                                flashcards: newData
                                              });
                                            }}
                                            placeholder="Please enter definition, you can only add line breaks 3 times"
                                            className="w-full min-h-[60px] px-3 py-2 text-base text-gray-900 border border-gray-300 rounded-lg focus:outline-none focus:border-indigo-600"
                                          />
                                          {row.definition.trim() === "" && (
                                            <p className="mt-1 text-sm text-red-600 h-6">Definition is required</p>
                                          )}
                                          {row.definition.split("\n").length > 3 && (
                                            <p className="mt-1 text-sm text-red-600 h-6">You can only add line breaks 3 times</p>
                                          )}
                                        </div>
                                      </div>
                                      {/* Additional Questions */}
                                      {row.moreQuestions.map((dt: any, i: number) => {
                                        return (
                                          <div key={dt.id} className="mt-6">
                                            <label className="font-bold text-xl mt-4 mb-2">Question {i + 1}</label>
                                            <div className="flex flex-wrap items-center gap-8">
                                              <div className="flex items-center">
                                                <input
                                                  id={`choiceTypeQuestion-${dt.id}-isYesNo`}
                                                  type="radio"
                                                  name={`choiceTypeQuestion-${dt.id}`}
                                                  value="isYesNo"
                                                  checked={dt.type === "isYesNo"}
                                                  onChange={() => handleQuestionChange(index, dt.id, "type", "isYesNo")}
                                                  className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300"
                                                />
                                                <label htmlFor={`choiceTypeQuestion-${dt.id}-isYesNo`} className="ml-2 block text-sm text-gray-900">
                                                  True / False
                                                </label>
                                              </div>
                                              <div className="flex items-center">
                                                <input
                                                  id={`choiceTypeQuestion-${dt.id}-isMultiple`}
                                                  type="radio"
                                                  name={`choiceTypeQuestion-${dt.id}`}
                                                  value="isMultiple"
                                                  checked={dt.type === "isMultiple"}
                                                  onChange={() => handleQuestionChange(index, dt.id, "type", "isMultiple")}
                                                  className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300"
                                                />
                                                <label htmlFor={`choiceTypeQuestion-${dt.id}-isMultiple`} className="ml-2 block text-sm text-gray-900">
                                                  Multiple
                                                </label>
                                              </div>
                                              <button
                                                type="button"
                                                className="inline-flex items-center px-4 py-2 border border-red-400 shadow-sm text-sm font-medium rounded-md text-red-800 bg-red-100 hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                                onClick={() => handleRemoveQuestion(index, dt.id)}
                                              >
                                                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                </svg>
                                                Remove
                                              </button>
                                            </div>
                                            <div className="mt-3">
                                              <label>Question</label>
                                              <textarea
                                                id={`question-${index}-${i}`}
                                                value={dt.question}
                                                onChange={(e) => handleQuestionChange(index, dt.id, "question", e.target.value)}
                                                rows={3}
                                                placeholder="Please enter question, you can only add line breaks 3 times"
                                                className="w-full px-3 py-2 text-base text-gray-900 border border-gray-300 rounded-lg focus:outline-none focus:border-indigo-600"
                                              />
                                              {dt.question.trim() === "" && (
                                                <p className="mt-1 text-sm text-red-600">Question is required</p>
                                              )}
                                              {dt.question.split("\n").length > 3 && (
                                                <p className="mt-1 text-sm text-red-600 h-6">You can only add line breaks 3 times</p>
                                              )}
                                            </div>
                                            {dt.answer.map((ans: string, ind: number) => (
                                              <div className="mt-3" key={`${dt.id}-${ind}`}>
                                                {dt.type === "isMultiple" ? (
                                                  <label>Answer {ChoiceAnswer[ind]}</label>
                                                ) : (
                                                  <div className="flex items-center justify-between">
                                                    <label>Answer {ind + 1}</label>
                                                    {dt.answer.length > 2 && (
                                                      <button
                                                        type="button"
                                                        className="inline-flex items-center px-3 py-1 border border-red-400 shadow-sm text-xs font-medium rounded-md text-red-800 bg-red-100 hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                                        onClick={() => handleRemoveAnswer(index, dt, ind)}
                                                      >
                                                        <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                        </svg>
                                                        Remove
                                                      </button>
                                                    )}
                                                  </div>
                                                )}
                                                <div className="flex items-center mb-2">
                                                  <input
                                                    id={uuidv4()}
                                                    type="radio"
                                                    name={`choiceCorrectAnswer-${index}-${dt.id}-${ind}`}
                                                    value={ChoiceAnswer[ind]}
                                                    checked={dt.correctAnswer === ans}
                                                    onChange={() => handleQuestionChange(index, dt.id, "correctAnswer", ans)}
                                                    className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300"
                                                  />
                                                  <label htmlFor={`choiceCorrectAnswer-${index}-${dt.id}-${ind}`} className="ml-2 block text-sm text-gray-900">
                                                    Correct Answer
                                                  </label>
                                                </div>
                                                <textarea
                                                  id={`answer-${index}-${dt.id}-${ind}`}
                                                  value={ans}
                                                  onChange={(e) => {
                                                    const updatedAnswers = [...dt.answer];
                                                    updatedAnswers[ind] = e.target.value;
                                                    handleQuestionChange(index, dt.id, "answer", updatedAnswers);
                                                  }}
                                                  rows={3}
                                                  placeholder="Please enter answer, you can only add line breaks 3 times"
                                                  className="w-full px-3 py-2 text-base text-gray-900 border border-gray-300 rounded-lg focus:outline-none focus:border-indigo-600"
                                                  disabled={dt.type !== "isMultiple"}
                                                />
                                                {ans.trim() === "" && (
                                                  <p className="mt-1 text-sm text-red-600">Answer is required</p>
                                                )}
                                                {ans.split("\n").length > 3 && (
                                                  <p className="mt-1 text-sm text-red-600 h-6">You can only add line breaks 3 times</p>
                                                )}
                                              </div>
                                            ))}
                                            <div id={`correct-answer-${index}-${i}`}></div>
                                            {(dt.answer.every((val: any) => val !== "") && dt.answer.every((val: any) => val.split("\n").length <= 3) && dt.correctAnswer.trim() === "") && (
                                              <p className="mt-1 text-sm text-red-600 h-6">Correct answer is required</p>
                                            )}
                                            {dt.type === "isYesNo" && (
                                              <div className="flex justify-end">
                                                <button
                                                  type="button"
                                                  className="mt-3 inline-flex items-center px-4 py-2 border border-blue-400 shadow-sm text-sm font-medium rounded-md text-blue-800 bg-blue-100 hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                                  onClick={() => handleAddMoreAnswer(index, dt)}
                                                >
                                                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                                                  </svg>
                                                  Add Answer
                                                </button>
                                              </div>
                                            )}
                                            {(row.moreQuestions.length !== 1 && row.moreQuestions.length - 1 !== i) && (
                                              <hr className="my-6 border-gray-300 dark:border-gray-700" />
                                            )}
                                          </div>
                                        )
                                      })}
                                      {/* Add Question Button */}
                                      <div className="mt-4">
                                        <button
                                          type="button"
                                          className="inline-flex items-center px-4 py-2 border border-yellow-400 shadow-sm text-sm font-medium rounded-md text-yellow-800 bg-yellow-100 hover:bg-yellow-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
                                          onClick={() => handleAddMoreQuestion(index)}
                                        >
                                          <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                                          </svg>
                                          Add Question
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>

                        <div className="mt-4 flex justify-between">
                          <button
                            onClick={() => {
                              console.log({
                                ...deckData,
                                flashcards: [
                                  ...excelData,
                                  { question: "", answer: "", image: "", sound: "", definition: "", moreQuestions: [] }
                                ]
                              });

                              setExcelData([
                                ...excelData,
                                { question: "", answer: "", image: "", sound: "", definition: "", moreQuestions: [] }
                              ]);
                              setDeckData({
                                ...deckData,
                                flashcards: [
                                  ...excelData,
                                  { question: "", answer: "", image: "", sound: "", definition: "", moreQuestions: [] }
                                ]
                              });

                              setExpandedCards(prev => [...prev, excelData.length]);
                            }}
                            className="px-4 py-2 text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition-colors"
                          >
                            Add New Flashcard
                          </button>
                          <div className="flex gap-2">
                            <button
                              onClick={() => {
                                setShowExcelModal(false);
                                setExcelData([]);
                                if (excelInputRef.current) {
                                  excelInputRef.current.value = '';
                                }
                                setFlashCards([]);
                              }}
                              className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
                            >
                              Cancel
                            </button>
                            <button
                              onClick={() => {
                                const hasErrors = validate();
                                if (!hasErrors) {
                                  handleImport();
                                } else {
                                  toast.warning("Validation failed - Please check your inputs");
                                  setTimeout(() => {
                                    validate()
                                  }, 200);
                                }
                              }}
                              className="px-4 py-2 text-white bg-green-600 rounded-lg hover:bg-green-700 transition-colors"
                            >
                              {isLoading ? (
                                <div className="flex items-center justify-center gap-2">
                                  <svg className="w-5 h-5 animate-spin mr-2" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                                  </svg>
                                  Importing...
                                </div>
                              ) : (
                                "Import"
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            </div>
          </div>
        </div>

      )}
    </div>
  );
}